var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTempWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48915 0.0197754C7.60102 0.0197754 6.88086 0.731455 6.88086 1.60908V12.5771L7.68513 12.2745V1.65587C7.68513 1.21709 8.04505 0.821724 8.48915 0.821724C8.93312 0.821724 9.29325 1.21709 9.29325 1.65587V12.2744L10.0971 12.5771V1.60908C10.0971 0.731419 9.37718 0.0197754 8.48915 0.0197754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29296 11.8128V12.6474C10.1435 12.9677 10.7478 13.7809 10.7478 14.7338C10.7478 15.967 9.73688 16.9665 8.48887 16.9665C7.24135 16.9665 6.22984 15.967 6.22984 14.7338C6.22984 13.7809 6.83431 12.9677 7.68488 12.6474V11.8127C6.38309 12.1618 5.42578 13.337 5.42578 14.734C5.42578 16.4061 6.79706 17.7613 8.4889 17.7613C10.181 17.7613 11.5518 16.4061 11.5518 14.734C11.5518 13.337 10.5946 12.1618 9.29296 11.8128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88091 7.1338C8.88091 6.91558 8.70856 6.73901 8.49641 6.73901H8.48024C8.26812 6.73901 8.09578 6.91561 8.09578 7.1338V13.0549C7.30384 13.239 6.70996 13.9663 6.70996 14.8346C6.70996 15.8415 7.50769 16.6606 8.48814 16.6606C9.469 16.6606 10.2668 15.8415 10.2668 14.8346C10.2668 13.9662 9.67292 13.2391 8.88091 13.0549V7.1338Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempWhite);
export default __webpack_public_path__ + "static/media/temp-white.696506a6.svg";
export { ForwardRef as ReactComponent };